
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/roca-bathroom-product",
      function () {
        return require("private-next-pages/case-study/roca-bathroom-product.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/roca-bathroom-product"])
      });
    }
  